export default __webpack_public_path__ + "static/media/Stalker's Armbands of Arcane Death.f112e5ce.jpg";